import React, { useState, useEffect } from 'react';
import Loader from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import * as processCosts from '../../Redux/Actions/processCost';
import { toastMessage } from '../../utils/toast';
import { useSelector, useDispatch } from 'react-redux';
import { clearSession } from '../../utils/initiate';
import Warning from '../Ui/400';
import ReactPaginate from 'react-paginate';
import DisplayAttributesModal from './displayAttributesModal';
import { search } from '../../utils';
import { setProcessListIdFilter, setProcessListNameFilter, resetProcessListFilter } from '../../Redux/Reducers/commonFilters';

const ProcessCosts = ({ history }) => {

    let itemsPerPage = 10;
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [displayAttributesModal, setDisplayAttributesModal] = useState(false);
    const [attributeData, setAttributeData] = useState([]);
    const [errStatus, setErrStatus] = useState(200);
    const userData = useSelector(({User}) => User.data);
    const dispatch = useDispatch();
    const [currentItems, setCurrentItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const [parmenentData, setParmenentData] = useState([]);
    const { t } = useTranslation();
    const { processListIdFilter, processListNameFilter } = useSelector(state => state.commonFilters);

    useEffect(() => {
        setLoading(true);
        processCosts.getAll().then(res => {
            if(res && res.data){
                setData(res.data);
                setParmenentData(res.data);
                if(processListIdFilter || processListNameFilter) {
                    handleFilter(res.data)
                }
            }else{
                toastMessage('error', 'Unable to get the process costs');
            }
            setLoading(false);
        }).catch(err => {
            setErrStatus(err.response.status);
            (err.response.status === 401) && clearSession(dispatch, history);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, history, userData]);

    useEffect(() => {
        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(data.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(data.length / itemsPerPage));
    }, [itemOffset, itemsPerPage, data]);

    const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage % data.length;
        setItemOffset(newOffset);
    };

    if(errStatus === 400){
        return <Warning history={history} />
    }

    const handleFilter = (arr) => {
        let temp = null;

        if(processListIdFilter && processListNameFilter) {
            const filtered = search({ items: arr, searchParams: ["id"], filterSearch: processListIdFilter });
            temp = search({ items: filtered, searchParams: ["name"], filterSearch: processListNameFilter });
        } else if(processListIdFilter) {
            temp = search({ items: arr, searchParams: ["id"], filterSearch: processListIdFilter });
        } else if(processListNameFilter) {
            temp = search({ items: arr, searchParams: ["name"], filterSearch: processListNameFilter });
        }

        temp && setData(temp);
    };
   
    const clearFilter = () => {
        setData(parmenentData);
        dispatch(resetProcessListFilter());
    }

    return (
        <div className="container-fluid">
            <div className="page-title-box">
                <h4 className="page-title my-2">{t("mastersManagement.processCost.processCosts")}</h4>
            </div>
            <div className="row">
                <div className="col-lg-12 col-xxl-12">
                    <div className="card card-custom card-stretch gutter-b">
                        {loading ? <Loader type="ThreeDots" color="#ad1a5f" height={40} width={40} style={{textAlign: 'center', marginBottom: '50px'}} />
                        : <div className="card-body py-3">
                            <div className="tab-content">
                                <div className="d-flex align-items-center mb-3">
                                    <div className="me-3" style={{ width: '20%' }}>
                                        <label className="mb-1 ms-1 me-3">{t("filter.id")}</label>
                                        <input placeholder={t("filter.idPlaceholder")} type="number" className="form-control me-3" name="Filter ID" value={processListIdFilter} onChange={(e) => dispatch(setProcessListIdFilter(e.target.value))} />
                                    </div>
                                    <div className="me-3" style={{ width: '20%' }}>
                                        <label className="mb-1 ms-1 me-3">{t("filter.name")}</label>
                                        <input placeholder={t("filter.namePlaceholder")} type="text" className="form-control me-3" name="Filter ID" value={processListNameFilter} onChange={(e) => dispatch(setProcessListNameFilter(e.target.value))} />
                                    </div>
                                </div>
                                <div className="d-flex mb-3">
                                    <button onClick={() => handleFilter(data)} type="button" className="d-flex px-5 align-items-center btn btn-primary font-weight-bold" >{t("jobsManagement.filters.filter")}</button>
                                    <button onClick={clearFilter} type="button" className="px-5 d-flex align-items-center btn btn-primary font-weight-bold mx-2" >{t("jobsManagement.filters.clearFilters")}</button>
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-head-custom table-vertical-center table-head-bg">
                                        <thead>
                                            <tr className="text-left">
                                                <th className="ps-5"><span className="text-dark-75">{t("mastersManagement.manage.id")}</span></th>
                                                <th><span className="text-dark-75">{t("mastersManagement.manage.name")}</span></th>
                                                <th><span className="text-dark-75">{t("mastersManagement.processCost.attributeCount")}</span></th>
                                                <th><span className="text-dark-75">{t("mastersManagement.processCost.amount")}</span></th>
                                                <th><span className="text-dark-75">{t("mastersManagement.manage.action")}</span></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentItems.map(({id, name, attributes, totalAmount}, index) => <tr key={index}>
                                                <td className="ps-5">
                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{id}</span>
                                                </td>
                                                <td className="pl-0 py-8">
                                                    <span className="text-dark-75 font-weight-bolder text-hover-primary d-block font-size-lg">{name}</span>
                                                </td>
                                                <td className="pl-0 py-8">
                                                    <span className="text-dark-75 font-weight-bolder text-hover-primary d-block font-size-lg">{attributes.length}</span>
                                                </td>
                                                <td className="pl-0 py-8">
                                                    <span className="text-dark-75 font-weight-bolder text-hover-primary d-block font-size-lg">{totalAmount}</span>
                                                </td>
                                                <td className="pl-0 py-8">
                                                    <p className="btn btn-warning font-weight-bolder font-size-sm me-2" onClick={() => {setDisplayAttributesModal(true); setAttributeData(attributes)}}>{t("mastersManagement.processCost.view")}</p>
                                                    <p className="btn btn-info font-weight-bolder font-size-sm me-2" onClick={() => history.push(`/master/process-cost/update?processCostID=${id}`)}>{t("mastersManagement.manage.update")}</p>
                                                    {/* <p className="btn btn-danger font-weight-bolder font-size-sm">{t("mastersManagement.processCost.delete")}</p> */}
                                                </td>
                                            </tr>)}
                                        </tbody>
                                    </table>
                                    {(pageCount > 1) && <ReactPaginate
                                        breakLabel="..."
                                        nextLabel=">"
                                        previousLabel="<"
                                        onPageChange={handlePageClick}
                                        pageRangeDisplayed={5}
                                        pageCount={pageCount}
                                        pageClassName="page-item"
                                        pageLinkClassName="page-link"
                                        previousClassName="page-item"
                                        previousLinkClassName="page-link"
                                        nextClassName="page-item"
                                        nextLinkClassName="page-link"
                                        breakClassName="page-item"
                                        breakLinkClassName="page-link"
                                        containerClassName="pagination"
                                        activeClassName="active"
                                        renderOnZeroPageCount={null}
                                    />}
                                    {(data.length === 0) && <p className="text-center mt-5 mb-5">{t("mastersManagement.noDataAvailable")}</p>}
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
            {displayAttributesModal && <DisplayAttributesModal t={t} showModal={displayAttributesModal} data={attributeData} handleCancel={() => setDisplayAttributesModal(false)} />}
        </div>
    );
};

export default ProcessCosts;